import React, {Component} from 'react';
import {
    Button,
    Modal,
    Form,
    Message,
    List
} from 'semantic-ui-react';
import update from 'react-addons-update';

import CustomDivider from "../extras/CustomDivider";
import {connect} from "react-redux";
import {addProductIngredient, listProductIngredients} from "../../actions/ProductIngredientActions";
import Loading from "../extras/Loading";
import {showAlert} from "../../actions/AlertAction";
import RecipeProductsPreMakeData from "../../data/RecipeProductsPreMakeData";
import {openModalRecipesProductsPreMake} from "../../actions/ModalRecipeProductsPreMakeActions";
import ProductData from "../../data/ProductData";
import RecipeProductPreMakeItem from "./RecipeProductPreMakeItem";

class RecipeProductsPreMakeDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            products: [],
            product_error: false,
            quantity_error: false,
            loading: true,
            data:{
                product:null,
                quantity:'',
                recipe: null
            },
            loading_add:false,
            id: null,
            options: [],
            height: 80
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.modal.id && nextProps.modal.id !== this.state.id){
            this.setState({loading:true, height:80, id: nextProps.modal.id});
            this.initialFetch(nextProps.modal.id);
        }
    }

    componentWillMount(){
        ProductData.listPreMaker().then(products => {
            let options = products.map(products => {
                return {key:products.id, value:products.id, text:`${products.name} `}
            });
            this.setState({options});
        });
    };

    async initialFetch(id) {
        let products = await RecipeProductsPreMakeData.list(id);
        let height = products.length > 0 ? 200:80;
        this.setState({loading: false, height});
        this.props.listProductIngredients(products);
    }

    handleClose = () => {
        this.setState({
            id: null,
            product_error: false,
            quantity_error: false,
            loading: false,
            loading_add: false,
            height: 80
        });
        this.props.openModalRecipesProductsPreMake({
            is_open:false,
            loading:false,
            name:null,
            id:null
        });
        this.props.listProductIngredients([]);
    };

    handleOpen = () => {
        this.setState({open: true});
    };

    async handleSubmit() {
        if(this.state.data.ingredient === null){
            this.setState({product_error:true});
        }else if(this.state.data.quantity < 0){
            this.setState({quantity_error:true});
        }else {
            let data = this.state.data;
            data.recipe = this.state.id;
            this.add(data);
        }
    };

    handleChange = (e, { name, value }) => {
        let ingredient = update(this.state, {
            data: {
                [name]: {$set: value}
            }
        });
        this.setState(ingredient);
        this.setState({product_error:false, quantity_error:false});
    };

    async add(data) {
        this.setState({loading_add:true});
        RecipeProductsPreMakeData.add(data, (res) => {
            if (res.save) {
                this.props.addProductIngredient(res.data);
            } else {
                this.props.showAlert({
                    show:true,
                    type:'error',
                    message:'Este producto ya está en la lista!'
                });
            }
            this.setState({loading_add:false});
        });
    };

    render() {
        let listItems = this.props.products.map(function (product) {
            return (
                <RecipeProductPreMakeItem {...product} key={product.id}/>
            )
        }, this);

        let data = (this.props.products.length > 0 ? listItems :
            <Message icon='bell' header='No hay información registrada'/>
        );

        return (
            <div>
                <Modal open={this.props.modal.is_open} dimmer='inverted' onClose={this.handleClose} size='tiny'>
                    <Modal.Header>{`Productos PreElaborados - ${this.props.modal.name}`}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Form.Group>
                                    <Form.Dropdown
                                        options={this.state.options}
                                        placeholder='Productos'
                                        name='product'
                                        onChange={this.handleChange}
                                        search
                                        selection
                                        error={this.state.product_error}
                                    />
                                    <Form.Input
                                        placeholder='Cant.'
                                        type='number'
                                        name='quantity'
                                        min={0}
                                        value={this.state.data.quantity}
                                        onChange={this.handleChange}
                                        error={this.state.quantity_error}
                                    />
                                    <Form.Button
                                        circular
                                        primary
                                        icon='add'
                                        disabled={this.state.loading_add}
                                        loading={this.state.loading_add}
                                    />
                                </Form.Group>
                            </Form>
                            <CustomDivider/>
                            <div className='modal-content-scroll' style={{height:this.state.height}}>
                                <List divided verticalAlign='middle'>
                                    {this.state.loading ? <Loading /> : data}
                                </List>
                            </div>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cerrar"/>
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch){
    return {
        listProductIngredients(product_ingredients) {
            dispatch(listProductIngredients(product_ingredients));
        },
        openModalRecipesProductsPreMake(modal){
            dispatch(openModalRecipesProductsPreMake(modal))
        },
        showAlert(alert) {
            dispatch(showAlert(alert));
        },
        addProductIngredient(ingredient){
            dispatch(addProductIngredient(ingredient))
        }
    }
}

function mapStateToProps(state){
    return{
        products: state.get('product_ingredients'),
        modal: state.get('modal_recipes_products_pre_make_reducer')
    };
}


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RecipeProductsPreMakeDialog)



// WEBPACK FOOTER //
// ./src/components/inventories/RecipeProductsPreMakeDialog.js